import React from 'react';
import PropTypes from 'prop-types';
import BaseDetailScreen from '../BaseDetailScreen';
import { SUPPORT_EMAIL } from '../../actions/urls';

import './ErrorPage.css';

const ErrorPage = props => (
  <div>
    <BaseDetailScreen
      pageHeading={props.pageHeading}
      backTo={props.backTo}
      backLabel={props.backLabel}
    >
      <div styleName="errorBody">
        {props.message}
      </div>
    </BaseDetailScreen>
  </div>
);

ErrorPage.propTypes = {
  backTo: PropTypes.string,
  backLabel: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  pageHeading: PropTypes.string,
};

ErrorPage.defaultProps = {
  backTo: '/',
  backLabel: 'Go Back',
  message: (
    <div styleName="errorMessage">
      Unfortunately, My IPO encountered an error. Please try again or &nbsp;<a styleName="errorLink" href={`mailto:${SUPPORT_EMAIL}`}>click here to contact support.</a>&nbsp;
    </div>
  ),
  pageHeading: 'My IPO Encountered an Error',
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/ErrorPage/ErrorPage.js